import React, { useContext } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Tooltip } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { ColorModeContext } from '../App';

const Navbar = () => {
  const location = useLocation();

  const { toggleColorMode, mode } = useContext(ColorModeContext);

  return (
    <AppBar position="sticky" color="default" enableColorOnDark>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
          FintechLab Screener
        </Typography>
        <Typography variant="caption" sx={{ mr: 2, opacity: 0.7, display: { xs: 'none', sm: 'block' } }}>
          No Code Stock Technical Screener
        </Typography>
        <Button
          color="inherit"
          component={Link}
          to="/"
          variant={location.pathname === '/' ? 'outlined' : 'text'}
          sx={{ mr: 1 }}
        >
          Home
        </Button>
        <Button
          color="inherit"
          component={Link}
          to="/screener"
          variant={location.pathname === '/screener' ? 'outlined' : 'text'}
          sx={{ mr: 1 }}
        >
          Screener
        </Button>
        <Button
          color="inherit"
          component={Link}
          to="/indicator-testing"
          variant={location.pathname === '/indicator-testing' ? 'outlined' : 'text'}
          sx={{ mr: 1 }}
        >
          Indicator Testing
        </Button>
        <Tooltip title={`Switch to ${mode === 'light' ? 'Dark' : 'Light'} mode`} arrow>
          <IconButton color="inherit" onClick={toggleColorMode} size="large">
            {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;